<app-page-header
  heading="Projects"
  subheading="Use projects to design, deploy, and manage your cloud resources."
  [actionButtons]="projectsActionButtons"
  [analyticsPrefix]="PROJECTS_PROJECT"
  (click)="handleProjectActions($event)"
></app-page-header>

<div [nbSpinner]="loading" style="min-height: 20rem">
  <ng-container>
    <div
      *ngIf="!loading"
      class="row d-flex mb-3"
      [ngClass]="{
        'justify-content-between': originalProjectsList?.length > 0,
        'justify-content-end': originalProjectsList?.length <= 0
      }"
    >
      <div *ngIf="originalProjectsList?.length > 0" class="col-xl-3 col-md-6">
        <nb-form-field>
          <input
            [formControl]="searchKey"
            placeholder="Find a project"
            type="text"
            fieldSize="small"
            fullWidth
            nbInput
            class="search-input rounded p-2"
            style="border: none !important"
            (input)="onSearchProject($event?.target?.value)"
          />
          <button
            style="border: none; background-color: #fff"
            class="rounded p-0"
            nbSuffix
            (click)="onSearchProject(searchKey?.value)"
          >
            <nb-icon
              class="heading-5"
              icon="search-outline"
              pack="eva"
            ></nb-icon>
          </button>
        </nb-form-field>
      </div>
      <div class="mode-switcher mr-3">
        <nb-select
          [selected]="mode"
          (selectedChange)="onFilterProject($event)"
          status="basic"
          size="small"
        >
          <nb-option
            *ngFor="let option of filterProjectsOptions"
            [value]="option?.value"
          >
            {{ option?.label }}
          </nb-option>
        </nb-select>
      </div>
    </div>

    <div *ngIf="originalProjectsList?.length > 0 && !loading" class="row">
      <div
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12"
        *ngFor="let project of filteredProjects"
      >
        <app-project-card-item [project]="project"></app-project-card-item>
      </div>
    </div>
  </ng-container>

  <!-- Empty state -->
  <ng-container *ngIf="filteredProjects?.length === 0 && !loading">
    <nb-card
      class="background-grey h-100 mr-auto ml-auto"
      [nbSpinner]="loading"
    >
      <nb-card-body class="mt-auto mb-auto h-100">
        <div class="w-100 text-center d-flex flex-column">
          <nb-icon
            class="w-100 h-100"
            icon="empty-state-default"
            pack="fci"
          ></nb-icon>
          <h6>
            No {{ this.mode }} Found
            {{ searchKey?.value?.trim() ? 'for ' + searchKey?.value : '' }}
          </h6>
          <div *ngIf="emptyStateDescription?.[mode] as descriptions">
            <p class="mb-0 mt-1">{{ descriptions?.[0] }}</p>
            <p *ngIf="mode === 'Projects' && !searchKey?.value?.trim()">
              {{ descriptions?.[1] }}
            </p>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </ng-container>
</div>

<ng-template #projectCreateFormPopup let-data let-ref="dialogRef">
  <app-create-project-form [dialogRef]="ref"></app-create-project-form>
</ng-template>
